"use strict";
export function cleanAmountMatchGroups(amount) {
  const regexMaybeDollar = /\$?/;
  const regexMaybeSign = new RegExp("(?<sign>-?)");
  const regexCentsOnly = new RegExp("([.,](?<centsOnly>\\d{1,2}))");
  const regexCentsAfterDollars = new RegExp("([.,](?<centsAfterDollars>\\d{1,2}))");
  const regexDollarsWithDelimitersOverMillion = /((\d{1,3})[.,](\d{3})[.,](\d{3}))/;
  const regexDollarsWithDelimitersUnderMillion = /((\d{1,3})[.,](\d{3}))/;
  const regexDollarsNoDelimiters = /(\d{1,9})/;
  const regexDollarsAndCents = new RegExp(
    "(?<dollars>(" + regexDollarsWithDelimitersOverMillion.source + "|" + regexDollarsWithDelimitersUnderMillion.source + "|" + regexDollarsNoDelimiters.source + "))(" + regexCentsAfterDollars.source + ")?"
  );
  const fullAmountRegex = new RegExp(
    regexMaybeDollar.source + regexMaybeSign.source + "(" + regexCentsOnly.source + "|" + regexDollarsAndCents.source + ")"
  );
  const amountWithoutWhitespace = amount.replace(/\s/g, "");
  const matches = fullAmountRegex.exec(amountWithoutWhitespace);
  if (!matches) return null;
  return matches.groups;
}
